import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Michael S.',
  location: 'Austin, TX, USA'
}, {
  name: 'Sarah J.',
  location: 'Denver, CO, USA'
}, {
  name: 'David L.',
  location: 'Portland, OR, USA'
}, {
  name: 'Emily R.',
  location: 'Seattle, WA, USA'
}, {
  name: 'James T.',
  location: 'Chicago, IL, USA'
}, {
  name: 'Jessica M.',
  location: 'Boston, MA, USA'
}, {
  name: 'Robert K.',
  location: 'San Diego, CA, USA'
}, {
  name: 'Amanda B.',
  location: 'Atlanta, GA, USA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-182">
          <div className="bg-white border-2 border-brand-orange shadow-[0_4px_22px_rgba(234,88,12,0.45)] rounded-lg p-2 pr-6 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-183">
            <span className="absolute left-0 top-0 bottom-0 w-1.5 bg-brand-teal" data-id="element-184" />
            <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close notification" data-id="element-185">
              <XIcon className="w-3.5 h-3.5" data-id="element-186" />
            </button>

            <div className="flex items-center gap-2.5 pl-1" data-id="element-187">
              <div className="w-8 h-8 rounded-full bg-brand-orange/15 flex items-center justify-center shrink-0 border border-brand-orange/40" data-id="element-188">
                <CheckCircle className="w-4 h-4 text-brand-orange" data-id="element-189" />
              </div>
              <div className="leading-tight" data-id="element-190">
                <p className="font-bold text-brand-navy text-[13px]" data-id="element-191">
                  {currentPurchase.name}
                </p>
                <p className="text-[10px] text-brand-ink/60 font-medium" data-id="element-192">
                  from {currentPurchase.location}
                </p>
                <p className="text-[11px] text-brand-teal font-bold mt-0.5" data-id="element-193">
                  purchased this digital book
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}